import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserNotificationViewModel } from '../models/viewmodels';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  private userNotificationSource = new Subject<UserNotificationViewModel>();
  userNotification$ = this.userNotificationSource.asObservable();
  notificationType?: string;

  constructor() { }

  displayErrorMessage(title: string, subTitle: string, message: string, notificationType?: string) {
    let notification: UserNotificationViewModel = {
      'Title': title,
      'SubTitle': subTitle,
      'Notification': message,
    };
    this.notificationType = notificationType;
    this.showUserNotification(notification);
  }

  displayedErrors(formGroup: any): boolean {

    let hasErrors: boolean = false;

    let errorMsg: string = '';
    let errors: string[] = [];
    for (let el in formGroup.controls) {
      if (formGroup.controls[el].errors) {
        //console.log(el)
        errors.push(el);
        errorMsg += el + ' is required. ';
      }
    }   
    //console.log('project-form', 'upsertProject', 'errors', errors);
    if (errors.length > 0) {
      hasErrors = true;
      let notification: UserNotificationViewModel = {
        'Title': 'Error - Invalid Data',
        'SubTitle': 'Required Data Missing.',
        'Notification': errorMsg,
      };
      this.showUserNotification(notification);
    }
    return hasErrors;
  }

  showUserNotification(userNotification: UserNotificationViewModel) {
    //console.log('user-notification.service', 'showUserNotification', userNotification)
    this.userNotificationSource.next(userNotification);
  }
}